import moment from "moment";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import {
  renderCellLeft,
  renderCellRight,
} from "../../utility/functions/common";

export const PurchaseSummaryColumns = (width) => {
  const columns = [
    {
      field: "EXP_DATE",
      accessor: "EXP_DATE",
      headerAlign: "center",

      width: width < 768 ? 100 : 100,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return renderCellLeft(
          params.value ? moment(params.value).format("DD-MM-yyyy") : ""
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Expiry Date
        </div>
      ),
    },
    {
      field: "ICODE",
      accessor: "ICODE",
      type: "string",
      headerAlign: "center",
      width: width < 768 ? 150 : width < 1400 ? 80 : 80,
      headerClassName: "super-app-theme--header",

      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Code
        </div>
      ),
    },

    {
      field: "ITEMNAME",
      accessor: "ITEMNAME",
      type: "string",
      width: width < 768 ? 200 : width < 1400 ? 250 : 250,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Item Name
        </div>
      ),
    },
    {
      field: "ACCOUNT_NO",
      accessor: "ACCOUNT_NO",
      type: "string",
      headerAlign: "center",
      width: width < 768 ? 150 : width < 1400 ? 80 : 80,
      headerClassName: "super-app-theme--header",

      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Acc No.
        </div>
      ),
    },
    {
      field: "NAME",
      accessor: "NAME",
      type: "string",
      width: width < 768 ? 150 : width < 1400 ? 250 : 220,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return renderCellLeft(param.value);
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Party Name
        </div>
      ),
    },
    {
      field: "BAL_STOCK",
      accessor: "BAL_STOCK",
      type: "string",
      headerAlign: "center",
      width: width < 768 ? 150 : width < 1400 ? 150 : 150,
      headerClassName: "super-app-theme--header",

      renderCell: (param) => {
        return renderCellRight(param.value.toFixed(3));
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Bal. Stock
        </div>
      ),
    },
  ];

  return columns;
};
